var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H5C3.34315 2 2 3.34315 2 5V8H4V5C4 4.44772 4.44772 4 5 4H8V2Z",
    fill: "#878793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19V16H4V19C4 19.5523 4.44772 20 5 20H8V22H5C3.34315 22 2 20.6569 2 19Z",
    fill: "#878793"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16V19C20 19.5523 19.5523 20 19 20H16V22H19C20.6569 22 22 20.6569 22 19V16H20Z",
    fill: "#878793"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5V8H20V5C20 4.44772 19.5523 4 19 4H16V2H19C20.6569 2 22 3.34315 22 5Z",
    fill: "#878793"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-live.adaec67f46096dcc0acb661522b6681c.svg";